import { createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';
import { LeaderboardResponse } from '../../models/api/responses/leaderboard.response';
import { LeaderboardActions } from '../actions/actions-type.action';

export interface LeaderboardState {
    sourceData: LeaderboardResponse | null;
    error: BadResponseWithError | null;
    isLoading: boolean;
}

const initialState: LeaderboardState = {
    sourceData: null,
    error: null,
    isLoading: false,
};

export const leaderboardReducer = createReducer(
    initialState,
    on(LeaderboardActions.fetchLeaderboardStatisticData, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        LeaderboardActions.fetchLeaderboardStatisticDataSuccess,
        (state, action) => ({
            ...state,
            sourceData: action.payload,
            isLoading: false,
        })
    ),
    on(
        LeaderboardActions.fetchLeaderboardStatisticDataFailure,
        (state, action) => ({
            ...state,
            error: action.error,
            isLoading: false,
        })
    )
);
